<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>
            {{ $t("applicant_info_add.title") }}
          </v-card-title>
          <v-divider color="white"></v-divider>
          <br />
          <!-- ที่อยู่ -->
          <div class="title1">
            {{ $t("applicant_info_add.address") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="address"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- เหตุผลในการเข้าศึกษา สจล. -->
          <div class="title1">
            {{ $t("applicant_info_add.user_detail_1") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="userDetail_1"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- ความสามารถพิเศษด้านภาษาอังกฤษ -->
          <div class="title1">
            {{ $t("applicant_info_add.user_detail_2") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="userDetail_2"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- ความสามารถพิเศษ -->
          <div class="title1">
            {{ $t("applicant_info_add.user_detail_3") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="userDetail_3"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- ประวัติการได้ทุน -->
          <div class="title1">
            {{ $t("applicant_info_add.user_detail_4") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="userDetail_4"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- ประวัติการแข่งกีฬา -->
          <div class="title1">
            {{ $t("applicant_info_add.user_detail_5") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="userDetail_5"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- ประวัติการอบรม / แข่งขัน / สอวน. -->
          <div class="title1">
            {{ $t("applicant_info_add.user_detail_6") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="userDetail_6"
                outlined
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import ApplicantInfoProvider from "@/services/applicant_info";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "ApplicantInfoAddUndergrad",
  data: function () {
    return {
      loading: false,
      form_validate_status: null,

      address: null,
      userDetail_1: null,
      userDetail_2: null,
      userDetail_3: null,
      userDetail_4: null,
      userDetail_5: null,
      userDetail_6: null,
      userDetail_7: null,
    };
  },
  components: {},

  methods: {
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      const uid = localStorage.getItem("uid");
      const data =
        await applicantInfoService.getApplicantInfoAdditionalUndergraduate(uid);

      this.address = data.ADDRESS;
      this.userDetail_1 = data.USER_DETAIL_1;
      this.userDetail_2 = data.USER_DETAIL_2;
      this.userDetail_3 = data.USER_DETAIL_3;
      this.userDetail_4 = data.USER_DETAIL_4;
      this.userDetail_5 = data.USER_DETAIL_5;
      this.userDetail_6 = data.USER_DETAIL_6;
      this.userDetail_7 = data.USER_DETAIL_7;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      const uid = localStorage.getItem("uid");
      const response = await applicantInfoService
        .setApplicantInfoAdditionalUndergraduate(
          {
            ADDRESS: this.address,
            USER_DETAIL_1: this.userDetail_1,
            USER_DETAIL_2: this.userDetail_2,
            USER_DETAIL_3: this.userDetail_3,
            USER_DETAIL_4: this.userDetail_4,
            USER_DETAIL_5: this.userDetail_5,
            USER_DETAIL_6: this.userDetail_6,
            USER_DETAIL_7: this.userDetail_7,
          },
          uid
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_data();
      this.loading = false;
      this.$router.push({ name: "registered_program_list" });
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
<style scoped>
.title1 {
  color: purple;
  font-size: 20px;
}
</style>
